const baseContactsApiPath = 'organizations/:organizationId/contacts';

export const contactsApiPaths = {
    contacts: baseContactsApiPath,
    contactsRoles: `${baseContactsApiPath}/roles`,
    contact: `${baseContactsApiPath}/:contactId`,
    contactRole: `${baseContactsApiPath}/:contactId/role`,
} as const;
